import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { ContributionMarginLevelDialogComponent } from './contribution-margin-level-dialog.component';

export * from './contribution-margin-level-dialog.component';
@NgModule({
    declarations: [ ContributionMarginLevelDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
    ],
})
export class ContributionMarginLevelDialogModule {
}
